/**
 * Shared `p0`…`p3` importance presentation — options for `EditableBadge` and
 * the badge variant per level. Used by both `CapabilityRow` (the map list)
 * and `CapabilityDrawer` (the detail view) so the two stay in lock-step
 * instead of drifting as two copies.
 *
 * @module features/product-map/importance
 */

import type { ProductMapImportance } from '@chatsdet/types';

export const IMPORTANCE_OPTIONS: Array<{ id: ProductMapImportance; label: string }> = [
  { id: 'p0', label: 'P0' },
  { id: 'p1', label: 'P1' },
  { id: 'p2', label: 'P2' },
  { id: 'p3', label: 'P3' },
];

export const IMPORTANCE_VARIANT: Record<ProductMapImportance, 'destructive' | 'warning' | 'default' | 'secondary'> = {
  p0: 'destructive',
  p1: 'warning',
  p2: 'default',
  p3: 'secondary',
};
